import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Activity, ActivityModel } from '../../../../models/activities';
import { Workflow } from '../../../../models';

@Component({
    selector: 'wm-activity-editor-base',
    templateUrl: './activity-editor-base.component.html',
    styleUrls: ['./activity-editor-base.component.css'],
    standalone: false
})
export class ActivityEditorBaseComponent implements OnInit {
  @Input() form: UntypedFormGroup;
  @Input() activity: Activity<ActivityModel>;
  @Output() saved: EventEmitter<any> = new EventEmitter<any>();
  @Output() loading: EventEmitter<any> = new EventEmitter<any>();
  @Input() workflow: Workflow;
  @Input() workflowVersionId: string;
  @Output() needsValidated: EventEmitter<any> = new EventEmitter<any>();
  @Input() loadTemplateCode: string;
  /**
   * There are some scenarios in which this editor needs to target a different jurisdiction for resources than the client that is on the context
   */
  @Input() targetClientId: string;
  /**
   * We need to know the difference between no targetClient passed, and Template Library being the target (null targetClientId)
   */
  @Input() globalTarget = false;

  constructor() {}

  ngOnInit() {}

  save(): boolean {
    return true;
  }
}
